import { ExternalActorType as GraphQLExternalActorType } from 'graphql-query-contracts';
import { ExternalActorType as DomainExternalActorType } from 'lane-shared/domains/billingPayments/types';

export function toGraphQLExternalActorType(
  domainType: DomainExternalActorType
): GraphQLExternalActorType {
  switch (domainType) {
    case DomainExternalActorType.EXTERNAL_ACTOR_TYPE_ACTIVATE_USER:
      return GraphQLExternalActorType.ExternalActorTypeActivateUser;
    case DomainExternalActorType.EXTERNAL_ACTOR_TYPE_UNKNOWN:
      return GraphQLExternalActorType.ExternalActorTypeUnknown;
    default:
      // Exhaustive check - if a new domain type is added, this will cause a compile error
      return GraphQLExternalActorType.ExternalActorTypeUnknown;
  }
}

export function toDomainExternalActorType(
  graphqlType: GraphQLExternalActorType
): DomainExternalActorType {
  switch (graphqlType) {
    case GraphQLExternalActorType.ExternalActorTypeActivateUser:
      return DomainExternalActorType.EXTERNAL_ACTOR_TYPE_ACTIVATE_USER;
    case GraphQLExternalActorType.ExternalActorTypeUnknown:
    case GraphQLExternalActorType.ExternalActorTypeSystem:
      // System type doesn't exist in domain enum, map to unknown
      return DomainExternalActorType.EXTERNAL_ACTOR_TYPE_UNKNOWN;
    default:
      // Safe fallback for any new GraphQL types
      return DomainExternalActorType.EXTERNAL_ACTOR_TYPE_UNKNOWN;
  }
}

/**
 * Helper to get the GraphQL enum for Activate User (most common use case)
 */
export function getActivateUserActorType(): GraphQLExternalActorType {
  return GraphQLExternalActorType.ExternalActorTypeActivateUser;
}

